import Dropdown from 'lib/components/Dropdown/Dropdown'
import AdminContext from 'lib/context/AdminContext'
import AuthContext from 'lib/context/AuthContext'
import { SignOutReason } from 'lib/hooks/useAuth'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AdminToggle from './AdminToggle'
import Avatar from './Avatar'

export default function AccountDropdown() {
  const { showAdminToggle } = useContext(AdminContext)
  const { self, logout } = useContext(AuthContext)
  const [isOpen, setIsOpen] = useState(false)
  const [t] = useTranslation()

  const openDropdown = () => setIsOpen(true)
  const closeDropdown = () => setIsOpen(false)

  return (
    <Dropdown>
      <Dropdown.Trigger onClick={openDropdown}>
        <Avatar self={self} />
      </Dropdown.Trigger>
      {isOpen && (
        <Dropdown.Menu onRequestClose={closeDropdown}>
          <Dropdown.MenuItem aProps={{ href: process.env.ACCOUNT_MANAGEMENT_URI }}>
            {t('header.accountMenu.account')}
          </Dropdown.MenuItem>
          <Dropdown.MenuItem onClick={() => logout(SignOutReason.UserSignOut)}>
            {t('header.accountMenu.signOut')}
          </Dropdown.MenuItem>
          {showAdminToggle && (
            <Dropdown.MenuItem>
              <AdminToggle onClick={event => event.stopPropagation()} />
            </Dropdown.MenuItem>
          )}
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}
